const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/settings/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { pickEnum, pickString } from "@/lib/search-params";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { requireAuth } from "@/routes/_app/guards";
import { getRootLoaderData } from "@/types/intl";
interface SettingsSearch {
  tab?: string;
  setup?: string;
  discogs?: "connected" | "error";
  spotify?: "connected" | "error";
  lastfm?: "connected" | "error";
}
const CONNECTION_CALLBACK_VALUES = ["connected", "error"] as const;
export const Route = createFileRoute("/_app/settings/")({
  beforeLoad: ({
    context: {
      queryClient
    },
    location
  }) => requireAuth({
    queryClient,
    location
  }),
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const tSettings = createTranslator({
      locale,
      messages,
      namespace: "globals.settings"
    });
    return {
      meta: buildPrivatePageMetaTags(tSettings("settings"))
    };
  },
  validateSearch: (search: Record<string, unknown>): SettingsSearch => {
    const pickRaw = (key: string) => search[key] as string | string[] | undefined;
    return {
      tab: pickString(pickRaw("tab")),
      setup: pickString(pickRaw("setup")),
      discogs: pickEnum(pickRaw("discogs"), CONNECTION_CALLBACK_VALUES),
      spotify: pickEnum(pickRaw("spotify"), CONNECTION_CALLBACK_VALUES),
      lastfm: pickEnum(pickRaw("lastfm"), CONNECTION_CALLBACK_VALUES)
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});